import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '100px',
      '& > div': {
        width: '100%',
        '@media (min-width: 724px)': {
          width: '80%'
        }
      }
    },
    finDeQuizTitle: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '1.25rem',
      lineHeight: '24px',
      margin: 'auto',
      color: palette.text.primary
    },
    finDeQuizAnswerContainer: {
      margin: '10px',
      padding: '10px',
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      backgroundColor: palette.background.underBox,
      borderRadius: '10px',
      '& > h2': {
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '1.25rem',
        lineHeight: '24px',
        color: palette.text.primary
      },
      '& > p': {
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '1rem',
        lineHeight: '24px',
        color: palette.text.primary
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
